import * as React from "react";
import {inject, observer} from "mobx-react";
import {Router as Router} from "react-router-dom";
import Master from "@templates/master";
import Grid from "@components/Grid/Grid"
import MyPages from "@components/MyPages/MyPages"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'


class LeftMenu extends React.Component {
    constructor(props) {

        super(props);
        this.navigateToSiteUrl = this.navigateToSiteUrl.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);

        this.state = {
            menuOpen: false
        }
    }

    navigateToSiteUrl(event, url, name) {
        event.preventDefault();
        this.props.navigation.navigateToSiteUrl(this.props.tree, url, name);
        this.props.navigation.closeToolbar();
    }

    toggleMenu(e) {
        this.setState({menuOpen: !this.state.menuOpen});
    }

    
    renderLevel(node, currentNode) {
        return (<ul className="">
            {node.Children.map(childPage => {
                return (
                    <li key={childPage.Id}
                        className={(childPage.IsHeading ? "menu-heading" : "") + " menu-item"}>
                        {childPage.IsHeading
                            ? childPage.Name
                            : <a href={childPage.Url} className={childPage.Id === this.props.navigation.NodeId ? "active" : ""}
                                 onClick={event => this.navigateToSiteUrl(event, childPage.Url, childPage.Name)}
                            ><span>{childPage.Name}</span></a>
                        }

                        {childPage.Children && childPage.Children.length > 0 && this.renderLevel(childPage, currentNode) }
                    </li>
                    

                );
            })}
        </ul>);
    }


    render() {
        if (!this.props.root) {
            return null;
        }

        return (
            <ul className={"left-menu " + (this.state.menuOpen ? "menu-open" : "")}>
                <li key={"menu-toggle"}
                    className="menu-item-toggle"
                >
                    <a href="#" onClick={this.toggleMenu}>Meny</a>
                </li>
                <li>
                    {this.renderLevel(this.props.root, this.props.currentNode)}
                </li>
            </ul>);
    }
}

@inject("store")
@observer
export default class IComReactComponent extends React.Component {
    constructor(props) {
        super(props);
    
    }


    getRootNode(node) {
        if(node.Parent !=  null){
            return this.getRootNode(node.Parent);
        }
        else{
            return node;
        }
    }

    render() {
        const pageContent = this.props.navigation.pageContent;
        const currentNode = this.props.store.navigation.CurrentNode;
        const root = this.getRootNode(currentNode);
        //const parent = this.props.navigation.CurrentNode ? this.props.navigation.CurrentNode.Parent : null;
        
        return (
            <Master {...this.props}>
                <div className={"wrapper"}>
                {pageContent && pageContent.Properties.pageMenu
                    ?
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 col-lg-3">
                                <LeftMenu navigation={this.props.navigation} root={root} currentNode={currentNode}/>
                            </div>
                            <div className="col-12 col-lg-9">
                                <MyPages component={pageContent.Properties.componentName}/>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <MyPages component={pageContent.Properties.componentName}/>
                            </div>
                        </div>
                    </div>

                }
                </div>
            </Master>
        );
    }
}

